/* Current Nostalgia — infinite scroll for collection grids.
   Loads the next page (via Shopify section rendering) as the shopper nears the bottom and
   appends its tiles. Page links stay in the HTML as a fallback but are hidden (CSS in the
   collection header) unless loading fails. Re-binds after filters/sorting re-render the grid.
   Also adds a back-to-top button, and fires a 'cn:grid' event whenever tiles are added so the
   size filter (cn-size-filter.js) can re-apply itself.
   v90: a size group split across two pages appears once - a tile whose data-cn-group is already
   in the grid is skipped when the next page is appended (snippets/cn-grid-item). */
(function () {
  if (window.__cnInfinite) return;
  window.__cnInfinite = true;
  var loading = false;
  var io = null;

  function nextUrl(root) {
    var a = (root || document).querySelector('.pagination-wrapper a.pagination__item--prev');
    return a ? a.getAttribute('href') : null;
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var wrap = grid.parentElement;
    var pag = wrap.querySelector('.pagination-wrapper');
    if (!pag) { fire('setup'); return; } /* one page of results: still let the size filter re-apply */
    pag.style.display = 'none';
    var url = nextUrl(wrap);
    var s = wrap.querySelector('[data-cn-sentinel]');
    if (!s) {
      s = document.createElement('div');
      s.setAttribute('data-cn-sentinel', '');
      s.className = 'cn-inf';
      s.innerHTML = '<span class="cn-inf__msg" hidden>Loading more…</span>';
      wrap.appendChild(s);
    }
    if (io) io.disconnect();
    if (!url) { delete s.dataset.next; fire('setup'); return; }
    s.dataset.next = url;
    io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '900px 0px' });
    io.observe(s);
    fire('setup');
  }

  // Lets other scripts (the size filter) know the grid changed.
  function fire(type) {
    try { document.dispatchEvent(new CustomEvent('cn:grid', { detail: type })); } catch (e) {}
  }

  function load() {
    var grid = document.getElementById('product-grid');
    var s = document.querySelector('[data-cn-sentinel]');
    if (loading || !grid || !s || !s.dataset.next) return;
    loading = true;
    var msg = s.querySelector('.cn-inf__msg');
    if (msg) msg.hidden = false;
    var u = new URL(s.dataset.next, window.location.href);
    if (grid.dataset.id) u.searchParams.set('section_id', grid.dataset.id);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('product-grid');
        if (ng) {
          Array.prototype.slice.call(ng.children).forEach(function (li) {
            var gid = li.getAttribute('data-cn-group');
            if (gid && grid.querySelector(':scope > li[data-cn-group="' + gid.replace(/["\\]/g, '') + '"]')) return;
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(document.importNode(li, true));
          });
        }
        var n = nextUrl(doc);
        if (n) { s.dataset.next = n; } else { delete s.dataset.next; if (io) io.disconnect(); }
        if (msg) msg.hidden = true;
        loading = false;
        // Re-observe so the observer reports the sentinel's current position (it only fires on
        // changes, so a sentinel that never left the viewport would otherwise stall loading).
        if (n && io) { io.unobserve(s); io.observe(s); }
        fire('append');
        requestAnimationFrame(check);
      })
      .catch(function () {
        loading = false;
        if (msg) msg.hidden = true;
        // Loading failed: bring the page links back so nobody gets stuck.
        document.documentElement.classList.add('cn-inf-off');
        var pag = document.querySelector('.pagination-wrapper');
        if (pag) pag.style.display = '';
        if (io) io.disconnect();
      });
  }

  // Backup for browsers or cases where the observer doesn't fire: check on scroll.
  function check() {
    var s = document.querySelector('[data-cn-sentinel]');
    if (s && s.dataset.next && !loading && s.getBoundingClientRect().top < window.innerHeight + 900) load();
  }
  window.cnInfLoad = load;
  window.cnInfCheck = check;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    setTimeout(function () { ticking = false; check(); }, 150);
  }, { passive: true });

  // Back-to-top button: appears once the shopper is well down the grid.
  function backToTop() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cn-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M4 12.5l6-6 6 6" fill="none" stroke="currentColor" stroke-width="1.6"/></svg><span>Top</span>';
    b.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(b);
    var shown = false;
    function toggle() {
      var show = window.scrollY > window.innerHeight * 1.5;
      if (show !== shown) { shown = show; b.classList.toggle('is-visible', show); }
    }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  function init() {
    setup();
    backToTop();
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      var t;
      new MutationObserver(function (muts) {
        // Ignore our own appends; re-bind when filters/sorting replace the grid.
        var replaced = muts.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')));
          });
        });
        if (!replaced) return;
        clearTimeout(t); t = setTimeout(setup, 60);
      }).observe(container, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
